import React from "react";
import { renderTags, hasTags } from "@/lib/mergeTags";

const BRIEF = "Review content brief and strategy";

export const ContentNamePreview = ({ flow, tags, name, social }) => {
  if (!tags) return null;
  const cfg = flow.content || {};
  const raw = (name || "").trim();
  const nm = renderTags(raw, tags) || (social ? "Post group name" : "Doc name");
  const t = { ...tags, NAME: nm, DOCNAME: nm };
  const step = (k, dflt) => { const title = cfg[k]?.title || dflt; return hasTags(title) ? renderTags(title, t) : `${title}: ${nm}`; };
  const main = renderTags(cfg.main_title || "", t).trim() || nm;
  const rows = [["Main task", main], ["First subtask", step("brief", BRIEF)], ["Then", step("draft", social ? "Draft posts" : "First draft")]];
  if (social || (raw && raw !== nm)) rows.splice(1, 0, [social ? "Post group" : "Doc", nm]);
  return (
    <div className="rounded-2xl border border-[#EEEFEF] bg-[#FCFCFE] p-3 space-y-1" data-testid="cf-import-name-preview">
      <p className="text-[10px] text-[#9FA1A4] font-mono-data uppercase tracking-wide">Names will read</p>
      {rows.map(([l, v]) => (
        <p key={l} className="text-sm flex gap-2"><span className="text-[#9FA1A4] w-24 shrink-0 text-xs pt-0.5">{l}</span><span className="text-[#06060C] font-medium" data-testid={`cf-preview-${l.toLowerCase().replace(/\s+/g, "-")}`}>{v}</span></p>
      ))}
    </div>
  );
};
